import { configureStore } from "@reduxjs/toolkit";

import loginReducer from "features/Login/loginSlice";
import artistListReducer from "customHooks/artistList/artistListSlice";
import modalReducer from "Modal/modalSlice";
import getInfoReducer from "components/Info/getInfoSlice";
import sideBarReducer from "components/SideBar/sideBarSlice";
import popupReducer from "components/ConfirmPopup/popupSlice";
import userReducer from "features/Users/usersSlice"
import verifiedUserReducer from "features/VerifiedUser/verifiedUsersSlice"
import unVerifiedUserReducer from "features/UnverifiedUser/unverifiedUsersSlice"
import pendingUserReducer from "features/PendingUser/pendingUsersSlice"
import partnerReducer from "features/AddPartner/partnerSlice"
import addNewsSlice from "features/AddNews/addNewsSlice"
import addPodcastSlice from "features/AddPodcast/addPodcastSlice";
import newsReducer from "features/News/newsSlice";
import podcastReducer from "features/Podcast/podcastSlice";
import verifyNewsReducer from "features/VerifyNews/verifyNewsSlice";
import verifyPodcastReducer from "features/VerifyPodcast/verifyPodcastSlice"
import statisticsReducer from "features/Statistics/statisticsSlice"

export default configureStore({
  reducer: {
    auth: loginReducer,
    artistList: artistListReducer,
    modal: modalReducer,
    info: getInfoReducer,
    sideBar: sideBarReducer,
    popup: popupReducer,
    user:userReducer,
    verifiedUser:verifiedUserReducer,
    unVerifiedUser:unVerifiedUserReducer,
    pendingUser:pendingUserReducer,
    addPartner:partnerReducer,
    addNews:addNewsSlice,
    addPodcast:addPodcastSlice,
    news:newsReducer,
    podcast:podcastReducer,
    verifyNews:verifyNewsReducer,
    verifyPodcast:verifyPodcastReducer,
    statistics:statisticsReducer
  },
});
